import "./Clients.css";
import ClientPage from "./ClientPage/ClientPage";
import ClientsSearchBar from "./ClientsSearchBar/ClientsSearchBar";
import { useEffect, useState } from "react";
import EditPopup from "./EditPopup/EditPopup";
import DeletePopup from "./DeletePopup/DeletePopup";
import { useAuth } from "../../Security/AuthProvider";
import { useNotification } from '../../Utils/Commons/Notification/NotificationContext';
import { useApiErrorHandler } from "../../Utils/Commons/apiErrorHandler";

const Clients = () => {
  const { getCredentials } = useAuth();
  const { notifySuccess } = useNotification();
  const { handleFetchError, handleResponseError } = useApiErrorHandler();
  const [editClient, setEditClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [deleteClient, setDeleteClient] = useState(null);
  const [filters, setFilters] = useState({});

  const fetchClients = async () => {
    try {
      const response = await fetch("/client/get-all", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          filters,
          company_name: getCredentials().company_name,
          company_password: getCredentials().company_password,
        }),
      });
      const data = await response.json();
      if (data.error) {
        handleResponseError(response, "Erreur lors de la récupération des clients");
        return;
      }
      setClients(data);
    } catch (error) {
      handleFetchError(error, "Erreur lors de la récupération des clients");
    }
  };

  const fetchDeleteClient = async (client) => {
    try {
      const response = await fetch(`/client/delete-client`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: client.id,
          company_name: getCredentials().company_name,
          company_password: getCredentials().company_password,
        }),
      });
      const data = await response.json();
      if (data.error) {
        handleResponseError(response, "Erreur lors de la suppression du client");
        return;
      }
      setDeleteClient(null);
      setClients(
        clients.filter((deletedClient) => deletedClient.id !== client.id)
      );
      notifySuccess("Client supprimé avec succès");
    } catch (error) {
      handleFetchError(error, "Erreur lors de la suppression du client");
    }
  };

  const fetchEditClient = async (client) => {
    try {
      const { company_name, company_password } = getCredentials();
      client.company_name = company_name;
      client.company_password = company_password;
      const response = await fetch(`/client/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(client),
      });
      const data = await response.json();
      if (data.error) {
        handleResponseError(response, "Erreur lors de la modification du client");
        return;
      }
      setEditClient(null);
      fetchClients();
      notifySuccess("Client modifié avec succès");
    } catch (error) {
      handleFetchError(error, "Erreur lors de la modification du client");
    }
  };

  const successFullRdv = (successClient) => {
    // Supprimer le client de la liste locale immédiatement
    setClients(clients.filter((client) => client.id !== successClient.id));
  };

  useEffect(() => {
    fetchClients();
  }, [filters]);

  return (
    <div className="clients">
      <ClientsSearchBar setFilters={setFilters} />
      <ClientPage
        clients={clients}
        setEditClient={setEditClient}
        setDeleteClient={setDeleteClient}
        setClients={setClients}
        successFullRdv={successFullRdv}
      />
      {editClient && (
        <EditPopup
          client={editClient}
          fetchEditClient={fetchEditClient}
          setEditClient={setEditClient}
        />
      )}
      {deleteClient && (
        <DeletePopup
          client={deleteClient}
          setDeleteClient={setDeleteClient}
          fetchDeleteClient={fetchDeleteClient}
        />
      )}
    </div>
  );
};

export default Clients;
